/* 🤖 this file was generated by svg-to-ts */
export const matIconStairs: {
  name: 'stairs';
  data: string;
} = {
  name: 'stairs',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 3h-4.42v3.33H11v3.33H8.42V16H6v2h4.42v-3.33H13v-3.33h2.58V8H18V6z"/></svg>`
};
